<div class="widget__wrap">
  <div class="widget" id="designboxes-widget">
    <h2 class="widget__header">
      <span class="widget__header__title">
        <i class="widget__header__icon ico-angle-down"></i> Designové boxy</span
      >
      <span class="widget__header__tools">
        <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
        <a
          [routerLink]="['designboxes/add']"
          class="cta cta--small cta--green"
        >
          <span class="cta__light">Přidat</span> box <i class="ico-plus"></i>
        </a>
      </span>
    </h2>
    <div class="widget__content">
      <swb-designboxes-list [query]="query"></swb-designboxes-list>
    </div>
  </div>
</div>
